const tipoFinalidadePatrimonioImobilizadoList = (listaCompleta) => {
    
    const tipoFinalidadePatrimonioImobilizadoListAux = [
        {
            id: 'P',
            descricao: 'Uso Próprio',
            ordem: 10,
        },
        {
            id: 'Z',
            descricao: 'Lazer',
            ordem: 20,
        },
        {
            id: 'L',
            descricao: 'Locação',
            ordem: 30,
        },
        {
            id: 'R',
            descricao: 'Renda',
            ordem: 40,
        },
        {
            id: 'I',
            descricao: 'Investimento',
            ordem: 50,
        },
        {
            id: 'V',
            descricao: 'Venda',
            ordem: 60,
        },
    ]

    if (listaCompleta) {

        tipoFinalidadePatrimonioImobilizadoListAux.push(
            {
                id: 'N', // HARDCODEBACKEND.idTipoFinalidadePatrimonioImobilizadoNaoInformada
                descricao: 'Não Informada',
                ordem: 90,
            },
        )
    }

    return tipoFinalidadePatrimonioImobilizadoListAux
}

export default tipoFinalidadePatrimonioImobilizadoList